import * as React from "react";

const AlertCircle: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="12" fill="#A8353C" stroke="none" stroke-width="2" />
            <path
                d="M10.649 6.493c-.08-.801.55-1.493 1.351-1.493s1.431.692 1.351 1.493l-.801 8.01c-.029.282-.266.497-.55.497s-.521-.215-.55-.498l-.801-8.009zm1.351 12.757c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"
                fill="#ffff"
                stroke="#ffff"
                stroke-width="1"
            />
        </svg>
    );
};

export default React.memo(AlertCircle);
